import { Link } from "react-router-dom";

export const plural = (n, w, ws) => `${n} ${n === 1 ? w : ws || `${w}s`}`;

const PRIO = { critical: "Critical", important: "Important", normal: "Normal", low: "Low" };
export function Prio({ level, testid }) {
  return <span className={`prio prio-${level}`} data-testid={testid}>{PRIO[level] || level}</span>;
}

// One metric box — uppercase label, one figure, one line of context. No icons, no colour unless the figure has meaning.
export function Metric({ label, value, sub, tone, to, testid }) {
  const body = (
    <>
      <div className="eyebrow !text-[10.5px]">{label}</div>
      <div className={`metric-value ${tone ? `metric-${tone}` : ""}`}>{value}</div>
      {sub && <div className="metric-sub truncate">{sub}</div>}
    </>
  );
  return to ? <Link to={to} className="metric metric-link" data-testid={testid}>{body}</Link> : <div className="metric" data-testid={testid}>{body}</div>;
}

// Section shell used across Home: quiet header, one optional right-hand control, flush body.
export function HomeSection({ title, count, action, children, testid, className = "" }) {
  return (
    <section className={`card min-w-0 ${className}`} data-testid={testid}>
      <div className="flex items-center justify-between gap-3 border-b border-line px-4 py-2.5">
        <h2 className="h2 flex items-center gap-2 text-[15px]">{title}{count != null && <span className="t3 text-[12px] font-medium" data-testid={testid ? `${testid}-count` : undefined}>{count}</span>}</h2>
        {action && <div className="flex shrink-0 items-center gap-2">{action}</div>}
      </div>
      {children}
    </section>
  );
}

export function EmptyLine({ children, action, testid }) {
  return <div className="flex items-center justify-between gap-3 px-4 py-4 text-[13px]" data-testid={testid}><span className="t3">{children}</span>{action}</div>;
}

export function HomeSkeleton() {
  return (
    <div className="space-y-4" data-testid="home-loading" aria-label="Loading">
      <div><div className="skeleton h-3.5 w-40" /><div className="skeleton mt-2 h-7 w-72" /></div>
      <div className="skeleton h-12" />
      <div className="skeleton h-[152px]" />
      <div className="skeleton h-[220px]" />
      <div className="skeleton h-[74px]" />
      <div className="skeleton h-[180px]" />
    </div>
  );
}
